import { getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiCaching } from "../config/cachingConfig";
import { fetchCrownpeakUrlDetails } from "../util/share";
import { getExitPopupTimerValue } from "../util/specialOffersTimer";

/*Special offers modal to be shown when user is idle for 1 seconds*/
document.addEventListener('DOMContentLoaded', async function () {
    // If isEnabled is false, exit the function early

    const modalDom = document.getElementById('sp-offer-modal');
    if (!modalDom) return;

    let idleTime = 0;
    let idleInterval: any;
    let timeoutDuration = 10 * 1000;
    const showCustomPage = showCustomPopup();
    if (showCustomPage) {
        const url = await getUrlPath();
        try {
            const offerDetails = await getCachedAPIResponse(url, apiCaching.OffersPopup);
            const { SpecialOfferExists } = offerDetails as { SpecialOfferExists: boolean };
            if (SpecialOfferExists && !sessionStorage.getItem('splOfferModalShown')) {
                timeoutDuration = await getExitPopupTimerValue();
                initIdleDetection();
            }
        } catch (error: any) {
            if (error.response?.status !== 404) {
                console.error('Error fetching data:', error);
            }
        }
    } else {
        if (!sessionStorage.getItem('splOfferModalShown')) {
            timeoutDuration = await getExitPopupTimerValue();
            initIdleDetection();
        }
    }



    function initIdleDetection() {
        idleTime = 0;
        idleInterval = setInterval(timerIncrement, 1000);

        // Event listeners for user activity
        document.addEventListener('mousemove', resetIdleTime);
        document.addEventListener('keypress', resetIdleTime);
        document.addEventListener('click', resetIdleTime);
        document.addEventListener('scroll', resetIdleTime);
    }

    function timerIncrement() {
     //  Increment in ms.Now idleTime is in ms
        idleTime += 1000; 
        if (idleTime > timeoutDuration) {
            showModal();
            clearInterval(idleInterval);
        }
    }

    function resetIdleTime() {
        idleTime = 0;
    }

    function showCustomPopup() {
        const modalDom = document.getElementById('sp-offer-modal');
        if (!modalDom) return false;

        // if this is "disable" then in CP it means "do not look for special offer"
        return modalDom.dataset.lookup === "enable";

    }

    function showModal() {
        const modal = document.getElementById('sp-offer-modal');
        const closeModalBtn = document.querySelector('.sp-offer-modal .close-modal-btn');
        if (!modal || !closeModalBtn) return;
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        modal.style.backgroundColor = "#00000066";
        sessionStorage.setItem('splOfferModalShown', 'true');

        const hideModal = () => {
            modal.classList.add('hidden');
            modal.classList.remove('flex');
            modal.style.backgroundColor = "";
            modal.removeEventListener('click', handleOutsideClick);
        };

        // Clicking the backdrop (anything outside the modal's inner content box)
        // closes the modal, matching the behavior of the other special-offer popup.
        const handleOutsideClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const modalContent = modal.querySelector('.modal-loc-inner');
            if (modalContent && !modalContent.contains(target)) {
                hideModal();
            }
        };

        closeModalBtn.addEventListener('click', hideModal);
        modal.addEventListener('click', handleOutsideClick);
    }
   async function getUrlPath() {
        const dbaName = localStorage.getItem('dbaName');
        const brandData = localStorage?.brandDetails ? JSON.parse(localStorage.brandDetails) : null;
        if (dbaName && brandData?.include_statename) {
            let weblocationInfo: any = (window as any).crownpeakWeblocationsByIdDetail;
            if (!weblocationInfo) {
                await fetchCrownpeakUrlDetails();
                weblocationInfo = (window as any).crownpeakWeblocationsByIdDetail;
                if (weblocationInfo) {
                    return `${window.location.origin}/specialoffermodalpopup/${dbaName}/${weblocationInfo?.stateName}`;
                }
                return `${window.location.origin}/specialoffermodalpopup/${dbaName}`;
            } else {
                return `${window.location.origin}/specialoffermodalpopup/${dbaName}/${weblocationInfo?.stateName}`;
            }
        } else if (dbaName) {
            return `${window.location.origin}/specialoffermodalpopup/${dbaName}`;
        } else {
            return `${window.location.origin}/specialoffermodalpopup/none`;
        }
    }
});
